<template>
  <div class="modal fade" id="modalAddUser" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Novo Usuário</h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label class="form-label m-0">Nome</label>
            <input
              v-model="formAdd.name"
              type="email"
              class="form-control"
              placeholder="Informe o nome"
            />
          </div>
          <div class="mb-3">
            <label class="form-label m-0">E-mail</label>
            <input
              v-model="formAdd.email"
              type="email"
              class="form-control"
              placeholder="Informe o e-mail"
            />
          </div>
          <div class="mb-3">
            <label class="form-label m-0">Senha</label>
            <div class="input-group">
              <input
                v-model="formAdd.password"
                :type="showPassword ? 'text' : 'password'"
                class="form-control"
                placeholder="Informe a senha"
              />
              <button
                @click="showPassword = !showPassword"
                class="btn btn-light border"
              >
                <i v-if="showPassword" class="bi bi-eye-slash"></i>
                <i v-else class="bi bi-eye"></i>
              </button>
              <button @click="generatePassword" class="btn btn-dark">
                Gerar
              </button>
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label m-0">Confirmar senha</label>
            <input
              v-model="formAdd.password_confirm"
              :type="showPassword ? 'text' : 'password'"
              class="form-control"
              placeholder="Confirme a senha"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Fechar
          </button>
          <button
            ref="btnAdd"
            @click="addUser()"
            type="button"
            class="btn btn-dark"
          >
            Adicionar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalAddUser",

  props: ["modal"],

  data() {
    return {
      showPassword: false,
      formAdd: {
        name: "",
        email: "",
        password: "",
        password_confirm: "",
      },
    };
  },

  methods: {
    async addUser() {
      this.$refs.btnAdd.innerText = "Adicionando...";
      this.$refs.btnAdd.disabled = true;

      await this.$api
        .post("/users", this.formAdd)
        .then((response) => {
          this.$toastr.s("Usuário adicionado com sucesso!", "Sucesso");
          this.$parent.users.unshift(response.data.user);
          this.clearFields();
          this.closeModal();
        })
        .catch((err) => {
          this.$toastr.e(err.response.data.message, "Erro");
        })
        .finally(() => {
          this.$refs.btnAdd.innerText = "Adicionar";
          this.$refs.btnAdd.disabled = false;
        });
    },

    generatePassword() {
      const chars =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+-={}:<>?";
      const password = Array(12)
        .fill("")
        .map(() => chars.charAt(Math.floor(Math.random() * chars.length)))
        .join("");
      this.formAdd.password = password;
      this.formAdd.password_confirm = password;
    },

    clearFields() {
      this.formAdd.name = "";
      this.formAdd.email = "";
      this.formAdd.password = "";
      this.formAdd.password_confirm = "";
    },

    closeModal() {
      this.modal.hide();
    },
  },
};
</script>

<style></style>
